import { PropsWithChildren } from 'react';
import { Link } from 'react-router';

import 'Modules/Home/HomeLayouts/HomeContainer.css';
import { IDataTestId } from '@custom';
import { Animated } from '@components/Animated';
import KobaiDefaultLogo from 'Modules/Home/HomeLayouts/Theme/KobaiDefaultLogo';
import KobaiEngine from 'assets/images/kobai-lock.png';
import HomeContainerFooter from './HomeContainerFooter';
import ThemedGradient from './Theme/ThemedGradient';

type TProps = {} & PropsWithChildren & IDataTestId;

const HomeContainerWithoutAside = ({ children, ...rest }: TProps) => {
  return (
    <Animated
      animationInDuration={500}
      animationOutDuration={300}
      className={
        'home tw:h-screen tw:flex-col tw:bg-primary-200 Roboto tw:flex tw:w-full tw:items-center'
      }
      onClick={undefined}
      innerRef={undefined}
    >
      <section
        data-testid={rest['data-testid'] ? `${rest['data-testid']}-container` : undefined}
        className={'home-container-without-aside mt5 tw:flex tw:bg-primary-100'}
      >
        <article
          className={
            'home-container-without-aside-messaging pa4 bg-black-pearl tw:flex-col tw:relative tw:flex tw:items-center tw:overflow-hidden'
          }
        >
          <Link to="/">
            <KobaiDefaultLogo />
          </Link>

          <Animated
            animationInDuration={1000}
            animationOutDuration={1000}
            animateOnMount={false}
            className={'tw:flex-col tw:z-1 tw:flex tw:items-center'}
            onClick={undefined}
            innerRef={undefined}
          >
            {children}
            <img
              src={KobaiEngine}
              alt="Kobai Engine"
              width="270"
              className="pb2 tw:z-1 tw:absolute bottom-2"
            />
          </Animated>

          <ThemedGradient />
        </article>
      </section>

      <HomeContainerFooter data-testid={rest['data-testid']} isSubmitting={false} />
    </Animated>
  );
};

export default HomeContainerWithoutAside;
